import {
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Box,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";

export function PopoverGenero({
  isOpen,
  setIsOpen,
  handleClick,
  labelTextoGenero,
  flex,
  anexo,
}) {
  return (
    <Popover
      focusRing={false}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement="bottom-start"
    >
      <PopoverTrigger>
        <Box
          display={flex ? "flex" : anexo ? "inline" : ""}
          onClick={() => handleClick()}
        >
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={anexo ? "12px" : "20px"}
            cursor="pointer"
          />
        </Box>
      </PopoverTrigger>
      <PopoverContent
        onClick={() => setIsOpen(false)}
        fontSize="md"
        maxWidth="250px"
        textAlign="justify"
        wordBreak={anexo && "break-all"}
        borderRadius="md"
        bg="gray.800"
        width="auto"
        color="white"
      >
        <PopoverBody>{labelTextoGenero}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
